import React, {useMemo,useState, useEffect} from "react";
import { Link,matchPath,useNavigate } from "react-router-dom";
import { useSelector,useDispatch,shallowEqual } from "react-redux";
import { useTheme } from "@mui/styles";
const { Grid,Box} = require("@mui/system");
import { GlobalRoutePath } from "@router/constants";
import { patient360Actions,patientTrialActions } from '@redux/actionCreators';

export const CUSTOM_MENU_TYPE = {PATIENT360:'PATIENT360',PATIENTTRIAL:'PATIENTTRIAL'}
const SX = {
    root:{
        margin:'8px 16px 16px',
        minHeight:'25%'
    },
    group:{
        minHeight:'25vh',
        "& .heading":{
            fontWeight:700,
            fontSize:16,
            whiteSpace:'nowrap',
            padding:'4px 12px',
        }
    },
    groupItems:(theme)=>({
        padding:0,
        '& li':{
            padding:'0px 12px',
            listStyle:'none',
            '& > a':{
                boxSizing: 'border-box',
                width: '100%',
                //display: 'flex',
                alignItems:'center',
                fontFamily: theme.typography.fontFamily.primary,
                fontSize: 14,
                fontWeight:500,
                textDecoration: 'none',
                padding: '4px 8px',
                color: theme.palette.text.blue.primary,
                lineHeight: '20px',
                whiteSpace:'nowrap',
                '&:hover,&.active':{ 
                    background: theme.palette.background.darkBlue,
                    color:'#fff',
                    fontWeight:700,
                    textDecoration:'underline', 
                }
      }
    }
    }),
    loader:{
        margin:1,
        display:'flex',
        alignItems:'center',
        justifyContent:'center',
        '& img':{
                maxWidth:'150px',
                objectFit:'scale-down',
                '&.loader-true':{
                    maxWidth:'20%',
                }
            }
    }
}
const MENU_CONFIG = {
    [CUSTOM_MENU_TYPE.PATIENT360]:{
        defaultItem:{path:GlobalRoutePath.PATIENT360.path,view_name:'Master View'},
        itemPath:GlobalRoutePath.VIEW.path,
        itemUrl:(item)=>`${GlobalRoutePath.PATIENT360.path}${item.view_id?`/${item.view_id}`:''}`,
        loadData:({clinicId})=>async dispatch =>await dispatch(patient360Actions.viewDetilsApi(clinicId))
    },
    [CUSTOM_MENU_TYPE.PATIENTTRIAL]:{
        itemPath:GlobalRoutePath.TRIAL_VIEW.path,
        itemUrl:(item)=>`${GlobalRoutePath.PATIENTTRIAL.path}${item.view_id?`/${item.view_id}`:''}`,
        loadData:({clinicId})=>async dispatch =>await dispatch(patientTrialActions.fetchViewList(clinicId))
    }
}
const maxItemsPerCol = 10; 
    
const CustomMenu = ({type=CUSTOM_MENU_TYPE.PATIENT360,open,handleClose,refreshMenu})=>{
    const config = MENU_CONFIG[type];
    const dispatch = useDispatch();
    const theme = useTheme();
    const [state,setState] = useState({loading:true});
    const { clinicId, viewList } = useSelector(state => ({
            clinicId: state.clinicReducer.selectedClinicId,
            viewList: {
                [CUSTOM_MENU_TYPE.PATIENT360]:state.patient360Reducer.viewDetails,
                [CUSTOM_MENU_TYPE.PATIENTTRIAL]:state.patientTrialReducer.views
            }
    }), shallowEqual);
    const loadData = async ()=>{
        const list = await dispatch(config.loadData({clinicId}));
        list == null && handleClose();
        //setState({loading:false});
    }
    useEffect(()=>{
        open && !viewList[type].init && loadData();
    },[open])
    useEffect(()=>{
        open && viewList[type].init && refreshMenu();
    },[viewList[type].init])
    const onSelect = (e)=>{
        //setSerchText('');
        handleClose(e);
    }
    const isSelected = (item)=>{
        const pathName = window.location.pathname;
        const matchedPath = matchPath({path: config.itemPath, caseSensitive: true, end: true},pathName);
        return (matchedPath && pathName == config.itemUrl(item)) || (!item.view_id && pathName == config.defaultItem?.path) 
    }
    const views = [...(config.defaultItem?[config.defaultItem]:[]),...(viewList[type]?.list || [])];
    
    const col = Math.ceil(views.length / maxItemsPerCol);
    return <Grid container sx={{...SX.root}}>
        {!viewList[type].init && <Grid size={12} sx={SX.loader}><img className="loader" src={'/static/images/loader_transparent.gif'}/></Grid>}
        {viewList[type].init && !!views.length && Array(col).fill(0).map((_v,gI)=><Grid size={12/col} sx={SX.group} key={gI}>
            <Box component="ul" sx={SX.groupItems(theme)}>
              {views.filter((v,i)=>i>=(maxItemsPerCol*gI) && i<(maxItemsPerCol*(gI+1))).map(item => 
                    <li key={item.view_id} onClick={onSelect}>
                        <Link className={isSelected(item) && 'active'} to={config.itemUrl(item)} title={item.view_name}>{item.view_name.ellipsis(30)}</Link>
                    </li>)}  
            </Box>
        </Grid>)}
    </Grid>
}

export default CustomMenu;